<template>

    <div class="addPostform">

        <div v-if="!submitted">
            <form class="form" @submit.prevent="">
                <div class="form-group">
                    <label for="url">Video URL</label>
                    <input id="url" type="url" v-model="url" class="form-control" :class="{'is-invalid':errorMsg}"/>
                    <div class="invalid-feedback">
                        {{errorMsg}}&nbsp;
                    </div>


                </div>
                <loading-indicator name="post.getVideoInfo" />
                <div v-if="preview" class="preview">

                    <post-button :method="doPost" :isLoading="isLoading" :classes="'btn btn-primary btn-lg mb-4'">
                        Post!
                    </post-button>
                    <h3>{{preview.title}}</h3>
                    <p><img :src="preview.preview"></p>

                </div>

            </form>
            <div class="mt-2">
              <a class="help" href="#" @click.prevent="showHowTo()">How to post a video on Pimblr?</a>
            </div>
            <hr>
            <h4>We proudly support:</h4>
            <p class="logos">
                <!--<a href="https://www.pornhub.com" ref="pornhub" target="_blank" style="background-color: #000"><img src="../../assets/img/logos/pornhub.png" title="Pornhub" alt="Pornhub"></a>-->
                <!--<a href="https://www.xhamster.com" ref="xhamster" target="_blank"><img src="../../assets/img/logos/xhamster.svg" title="xHamster" alt="xHamster"></a>-->
                <!--<a href="https://www.spankwire.com" ref="spankwire" target="_blank"><img src="../../assets/img/logos/spankwire.png" title="Spankwire" alt="Spankwire"></a>-->
                <a href="https://dirtyship.com" ref="dirtyship" target="_blank"><img src="../../assets/img/logos/dirtyship.png" title="DirtyShip" alt="DirtyShip"></a>
                <!--<a href="https://www.tumblr.com" ref="tumblr" target="_blank" style="background-color: #36465D"><img src="../../assets/img/logos/tumblr.png" title="tumblr" alt="tumblr"></a>-->
                <!--<a href="https://www.porndig.com" ref="Porndig" target="_blank"><img src="../../assets/img/logos/porndig.png" title="Porndig" alt="Porndig"></a>-->
                <!--<a href="https://www.xnxx.com" ref="xnxx" target="_blank"><img src="../../assets/img/logos/xnxx.png" title="XNXX" alt="XNXX"></a>-->
                <!--<a href="https://www.xvideos.com" ref="xvideos" target="_blank" style="background-color: #000"><img src="../../assets/img/logos/xvideos.svg" title="XVideos" alt="XVideos"></a>-->
                <a href="https://www.youjizz.com" ref="youjizz" target="_blank" style="background-color: #000"><img src="../../assets/img/logos/youjizz.png" title="YouJizz" alt="YouJizz"></a>
                <a href="https://nsfw247.to" ref="nsfw247" target="_blank"><img src="../../assets/img/logos/NSFWonSnap.png" title="NSFW on Snap" alt="NSFW on Snap"></a>
                <a href="https://hotscope.tv" ref="hotscope" target="_blank"><img src="../../assets/img/logos/hotscope.png" title="Hotscope" alt="Hotscope"></a>
                <a href="https://tiktits.com" ref="tiktits" target="_blank"><img src="../../assets/img/logos/tiktits.svg" title="Tiktits" alt="Tiktits"></a>
                <a href="https://www.hypnotube.com" ref="hypnotube" target="_blank"><img src="../../assets/img/logos/hypnotube.png" title="hypnotube" alt="hypnotube"></a>
                <a href="https://www.motherless.com" ref="motherless" target="_blank" style="background-color: #000"><img src="../../assets/img/logos/motherless.png" title="motherless" alt="motherless"></a>
                <a href="https://www.ashemaletube.com" ref="ashemaletube" target="_blank" style="background-color: #000"><img src="../../assets/img/logos/ashemaletube.png" title="A Shemale Tube" alt="A Shemale Tube"></a>
                <a href="https://www.sex.com" ref="sexdotcom" target="_blank" style=""><img src="../../assets/img/logos/sexdotcom.png" title="Sex.com" alt="Sex.com"></a>
                <a href="https://www.sheshaft.com" ref="sheshaft" target="_blank" style="background-color: #2F333F"><img src="../../assets/img/logos/sheshaft.png" title="SheShaft" alt="SheShaft"></a>
                <a href="https://www.eroprofile.com" ref="eroprofile" target="_blank" style="background-color: #0069C6"><img src="../../assets/img/logos/eroprofile.png" title="EroProfile" alt="EroProfile"></a>
                <a href="https://www.youtrannytube.com" ref="youtrannytube" target="_blank" style="background-color: #2A2A2A"><img src="../../assets/img/logos/youtrannytube.png" title="You Tranny Tube" alt="You Tranny Tube"></a>
                <a href="https://www.fulltrannytube.com" ref="fulltrannytube" target="_blank" style=""><img src="../../assets/img/logos/fulltrannytube.png" title="Full Tranny Tube" alt="Full Tranny Tube"></a>
                <a href="https://www.trannytube.tv" ref="trannytubetv" target="_blank" style="background-color: rgb(28, 40, 49)"><img src="../../assets/img/logos/trannytubetv.png" title="Tranny Tube TV" alt="Tranny Tube TV"></a>
            </p>
            <p>
                <a href="#" @click.prevent="missingPortal">Missig a portal?</a>
            </p>
        </div>


        <div v-else>
            <success-icon/>
        </div>



    </div>
</template>

<script>

    import PostButton from '../ui/buttons/PostToBlogButton.vue';
    import SuccessIcon from '../ui/SuccessIcon.vue';
    import LoadingIndicator from '../ui/LoadingIndicator.vue';
    import Icon from "../ui/Icon";
    import IndicatorButton from "../ui/buttons/IndicatorButton";

    export default {
        name: 'AddPost',
        props: ['savedMethod'],
        data() {
            return {
                url: '',
                preview: false,
                submitted: false,
                isLoading: false,
                errorMsg: ''
            }
        },
        created() {
            if(this.$route.query.url){
                this.url = this.$route.query.url
            }
            if(this.$route.query.b){
                this.url = atob(this.$route.query.b)
            }
        },
        watch:{
            url(url){
                this.preview = false;
                this.errorMsg = '';

                const previews = [
                    // {name:"pornhub",  logo:require('../../assets/img/logos/pornhub.png'),  reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?pornhub\.com\/view_video.php\?viewkey=(ph[a-f0-9]{13})|([\d]{5,})$/)},
                    // {name:"xhamster", logo:require('../../assets/img/logos/xhamster.svg'),  reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?xhamster\.com\/videos\/([a-z0-9-])+-([0-9]{3,})/)},
                    // {name:"tumblr",   logo:require('../../assets/img/logos/tumblr.png'), reg: new RegExp(/^http[s]?:\/\/([^\.]+)\.tumblr\.com\/post\/([^\/]+)*/)},
                    // {name:"xnxx",     logo:require('../../assets/img/logos/xnxx.png'), reg: new RegExp(/^http[s]?:\/\/([^\.]+)\.xnxx\.com\/video-([0-9a-z]{6,8})\/.*/)},
                    // {name:"xvideos",  logo:require('../../assets/img/logos/xvideos.svg'), reg: new RegExp(/^http[s]?:\/\/([^\.]+)\.xvideos\.com\/video([0-9a-z]{6,8})\/.*/)},
                    {name:"dirtyship",  logo:require('../../assets/img/logos/dirtyship.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?dirtyship\.com\/([0-9a-z-]{5,})\//)},
                    {name:"tiktits",  logo:require('../../assets/img/logos/tiktits.svg'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?tiktits\.com\/video\/([0-9a-z-]{3,})/)},
                    {name:"motherless",  logo:require('../../assets/img/logos/motherless.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?motherless\.com\/([0-9A-Z]{6,8})/)},
                    {name:"hypnotube",  logo:require('../../assets/img/logos/hypnotube.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?hypnotube\.com\/video\/.*-(\d{1,})\.html/)},
                    {name:"ashemaletube", logo:require('../../assets/img/logos/ashemaletube.png'), reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?ashemaletube\.com\/videos\/.*[\d]{4,}\/.*/)},
                    {name:"porndig", logo:require('../../assets/img/logos/porndig.png'), reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?porndig\.com\/videos\/[\d]{2,}\/.+\.html/)},
                    {name:"sexdotcom", logo:require('../../assets/img/logos/sexdotcom.png'), reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?sex\.com\/pin\/([0-9]{4,}).+/)},
                    {name:"sheshaft", logo:require('../../assets/img/logos/sheshaft.png'), reg: new RegExp(/^https:\/\/([a-z]{2,}\.)?sheshaft\.com\/videos\/([0-9]{4,})\/.+/)},
                    {name:"eroprofile", logo:require('../../assets/img/logos/sheshaft.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?eroprofile\.com\/m\/videos\/view\/.+/)},
                    {name:"youjizz", logo:require('../../assets/img/logos/youjizz.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?youjizz\.com\/videos\/([a-z0-9-])+-([0-9]{3,})\.html/)},
                    {name:"nsfwonsnap", logo:require('../../assets/img/logos/NSFWonSnap.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?nsfw247\.to\/([a-z0-9-])/)},
                    {name:"hotscope", logo:require('../../assets/img/logos/hotscope.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?hotscope\.tv\/(porn|periscope|snapchat)\/([0-9])/)},
                    {name:"youtrannytube", logo:require('../../assets/img/logos/youtrannytube.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?youtrannytube\.com\/(gallery\/)?([a-z0-9-])+-([0-9]{3,})\.html/)},
                    {name:"fulltrannytube", logo:require('../../assets/img/logos/fulltrannytube.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?fulltrannytube\.com\/(view|gallery)\/([0-9]{3,})+-([a-z0-9-])/)},
                    {name:"trannytubetv", logo:require('../../assets/img/logos/trannytubetv.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?trannytube\.tv\/movies\/([0-9]{3,})\/([a-z0-9-])/)},
                    // {name:"spankwire", logo:require('../../assets/img/logos/spankwire.png'), reg: new RegExp(/^http[s]?:\/\/([a-z]{2,}\.)?spankwire\.com\/.*\/video([0-9]+)\//)}

                ];
                let portal = previews.find((port)=>{
                     if(port.reg.test(url)) return port;
                });
                if(portal){
                    this.$api.getVideoInfo(url).then((res)=>{
                        if(res.status==404){
                            this.errorMsg = res.data.message;
                            return false;
                        }
                        this.preview = res.data.data;
                        this.preview.portal = portal;
                    })
                    .catch((res)=>{
                        this.errorMsg = res.response.data.message;
                    });
                } else {
                    if(url.length>1){
                        this.errorMsg = 'Please provide a valid Video URL'
                    }
                }
            }
        },
        methods: {
            doPost(blog, callback){
                this.isLoading = true;
                this.$api.addPost(blog.url, this.url).then((res)=>{
                    this.isLoading = false;
                    this.url = '';
                    this.submitted = true;
                    callback(false);
                    setTimeout(()=>{
                        if(this.savedMethod){
                            this.savedMethod();
                        }
                        this.submitted = false;
                    }, 2000);
                }).catch(() => {
                  this.isLoading = false;
                });
            },
            missingPortal(){
                this.$bus.$emit('feedback.open', 'I am missing the portal: ');
            },
            showHowTo(){
                this.$bus.$emit('ShowHowToPostVideo');
            }
        },
        components: {
          IndicatorButton,
            Icon,
            PostButton,
            SuccessIcon,
            LoadingIndicator
        }
    }
</script>

<style lang="sass" scoped>
    @import '../../assets/sass/vars.scss'

    .help
        color: #AAA
        transition: color .2s ease-in-out
        text-decoration: none

        &:hover
            color: $colorPrimary

    .logos a
        display: inline-block
        padding: 4px
        margin-right: 4px
        margin-bottom: 6px

        &:hover
            opacity: .7

        img
            max-height: 26px
            width: auto
    .preview
        text-align: center

        img
            max-width: 100%
            height: auto

    button svg.fa-spin
        display: none

    button:disabled svg.fa-spin
        display: inline-block
</style>



// WEBPACK FOOTER //
// src/components/posts/AddPostForm.vue